"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = CrossSmall;
var _CrossSmall = require("@adobe/react-spectrum-ui/dist/CrossSmall.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function CrossSmall(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_CrossSmall.CrossSmall, null));
}